import { useDeviceType } from '@cian/ui-kit';
import { useCallback } from 'react';
import { NewUserBonusBanner } from 'shared/components/NewUserBonusBanner';
import { useAppDispatch } from 'shared/hooks';
import { setVisible } from 'shared/slices';

export const NewUserBonusBannerContainer: React.FC = () => {
  const device = useDeviceType();

  const dispatch = useAppDispatch();

  const isPhone = device === 'phone';

  const btnSize = isPhone ? 'M' : 'L';

  const themeType = isPhone ? 'light' : 'colored';

  const handleModalOpen = useCallback(() => {
    dispatch(setVisible(true));
  }, [dispatch]);

  return (
    <NewUserBonusBanner
      device={device}
      btnProps={{ size: btnSize, color: 'fill_primary', onClick: handleModalOpen }}
      themeType={themeType}
    />
  );
};
